import * as React from 'react';

export const UpDownArrow = ({ headingDown, className }: { headingDown: boolean, className?: string }) => {
    return (
        <i className={`inline-block border-current border-r-[3px] border-b-[3px] p-[3px] width-[0.3em] height-[0.3em] relative
            ${headingDown ? 'rotate-45 bottom-[0.1em]' : 'rotate-[-135deg] top-[0.1em]'} ${className}`}>
        </i>
    )
}

export const LeftRightArrow = ({ headingLeft, className }: { headingLeft: boolean, className?: string }) => {
    return (
        <i className={`inline-block border-current border-r-[3px] border-b-[3px] p-[0.2em] origin-center relative
                ${headingLeft ? 'rotate-[135deg] left-[0.1em]' : 'rotate-[-45deg] right-[0.1em]'} ${className}`}>
        </i>
    )
}
